
import React from "react";

const FreeStrategyFeatures = () => {
  const freeFeatures = [
    "**No Subscription Required** – Access is completely free, with no monthly or annual fees.",
    "**Community Sourced** – These strategies are contributed by the broader trading community.",
    "**Limited Vetting** – Metrade does not perform an in-depth review or guarantee performance.",
    "**Basic Performance Data** – Users can view core metrics, but advanced analytics may be limited."
  ];

  return (
    <div className="bg-gray-50 p-6 rounded-lg mb-6">
      <ul className="space-y-4">
        {freeFeatures.map((feature, index) => (
          <li key={index} className="text-gray-700">
            {feature.split('**').map((part, i) => 
              i % 2 === 0 ? part : <strong key={i}>{part}</strong>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FreeStrategyFeatures;
